var _defs, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "a",
    width: 16,
    height: 21,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAVCAMAAAB44J7gAAAAAXNSR0IB2cksfwAAANVQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADmVSEQAAAEd0Uk5TABSI3KbLkSHm/6vprLHH67rE+r69xal12/Uuw7SZynAy4ER+1wQL7WBL4QYbGqUo7mIQ1N070ooCHOpIL5tmrmcMQ7/y5R841DB7AAAApElEQVR4nF3OVxaCUAwE0IigRkSxd0WlWLD33t3/koygEJyvvHvm5AUgJIRFKQJeojHEuCT7kEBEJckgRaCmGWQIsrm/Rr5Q9KGEWK4ASxWxxt9QR2wEoEk7NA4aQTJQaZG0OXQIdIOBaZF0eaVH0B/QYA+/MiIRDXOsT6YuzOb4yWK5wvXGke3OEWuvoOp2DrIjeDz9rrbPrlyu3l+3++MpvADeJqwNZ9IsiHwAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22 42.5C10.7 42.5 1.5 33.3 1.5 22S10.7 1.5 22 1.5 42.5 10.7 42.5 22 33.3 42.5 22 42.5z",
    style: {
      fill: "none",
      stroke: "#222",
      strokeWidth: 3
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 14,
    y: 11,
    href: "#a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.387a3ef2c055bac19469c703d5ee0294.svg";
export { ForwardRef as ReactComponent };